<div class="modal-container">
    <div class="modal-header">
        <h2 class="modal-title">New User</h2>
        <button class="close-btn" (click)="onClose()" type="button">
            &times;
        </button>
    </div>
    <div class="modal-body scrollbar-custom">
        <form
            [formGroup]="userForm"
            (ngSubmit)="onSubmit()"
            class="add-user-form"
        >
            <!-- Row 1: Name and Phone -->
            <div class="form-row mb-3">
                <div class="form-group">
                    <label for="name"
                        >Name <span class="text-danger-required">*</span></label
                    >
                    <input
                        type="text"
                        id="name"
                        class="form-control"
                        formControlName="name"
                        placeholder="Please enter your name"
                    />
                    <div
                        *ngIf="f.name.touched && f.name.invalid"
                        class="text-danger"
                    >
                        <span *ngIf="f.name.errors?.required"
                            >Name is required.</span
                        >
                    </div>
                </div>

                <div class="form-group">
                    <label for="phone"
                        >Phone
                        <span class="text-danger-required">*</span></label
                    >
                    <input
                        type="tel"
                        id="phone"
                        class="form-control"
                        formControlName="phone"
                        pattern="\d*"
                        inputmode="numeric"
                        placeholder="Please enter your phone"
                    />
                    <div
                        class="text-danger"
                        *ngIf="f.phone.invalid && f.phone.touched"
                    >
                        <div *ngIf="f.phone.errors?.['required']">
                            Phone number is required.
                        </div>
                        <div *ngIf="f.phone.errors?.['pattern']">
                            Invalid phone number. Must be 10 digits, starting
                            with 05.
                        </div>
                    </div>
                </div>
            </div>

            <!-- Row 2: Employee ID and Email -->
            <div class="form-row mb-3">
                <div class="form-group">
                    <label for="employeeId"
                        >Employee ID
                        <span class="text-danger-required">*</span></label
                    >
                    <input
                        type="text"
                        id="employeeId"
                        class="form-control"
                        formControlName="employeeId"
                        placeholder="Please enter ID"
                    />
                    <div
                        *ngIf="f.employeeId.touched && f.employeeId.invalid"
                        class="text-danger"
                    >
                        <span *ngIf="f.employeeId.errors?.required"
                            >Employee ID is required.</span
                        >
                    </div>
                </div>

                <div class="form-group">
                    <label for="email"
                        >Email ID
                        <span class="text-danger-required">*</span></label
                    >
                    <input
                        type="text"
                        id="email"
                        class="form-control"
                        formControlName="email"
                        placeholder="Please enter email"
                    />
                    <div
                        *ngIf="f.email.touched && f.email.invalid"
                        class="text-danger"
                    >
                        <span *ngIf="f.email.errors?.required"
                            >Email required.</span
                        >
                        <div *ngIf="f.email.errors?.['pattern']">
                            Invalid email address.
                        </div>
                    </div>
                </div>
            </div>

            <!-- Row 3: Country and User Role -->
            <div class="form-row mb-3">
                <div class="form-group">
                    <label for="country"
                        >Country
                        <span class="text-danger-required">*</span></label
                    >
                    <div class="disabled-country-list">
                        <lib-country-list
                            selectedCountryCode="SA"
                            (onCountryChange)="onCountryChange($event)"
                        ></lib-country-list>
                    </div>
                </div>

                <div class="form-group">
                    <label for="userRole"
                        >User Role
                        <span class="text-danger-required">*</span></label
                    >
                    <select
                        id="userRole"
                        class="form-control"
                        formControlName="roleId"
                    >
                        <option value="">Select</option>
                        <option *ngFor="let role of roles" [value]="role.id">
                            {{ role.name }}
                        </option>
                    </select>
                    <div
                        *ngIf="f.roleId.touched && f.roleId.invalid"
                        class="text-danger"
                    >
                        <span *ngIf="f.roleId.errors?.required"
                            >User Role is required.</span
                        >
                    </div>
                </div>
            </div>

            <!-- Row 4: Password and Confirm Password -->
            <div class="form-row mb-3">
                <div class="form-group">
                    <label for="password"
                        >Password
                        <span class="text-danger-required">*</span></label
                    >
                    <div class="password-input-container">
                        <input
                            formControlName="password"
                            [type]="showPassword ? 'text' : 'password'"
                            id="password"
                            class="form-control"
                            placeholder="Please enter your password"
                            autocomplete="new-password"
                        />
                        <button
                            type="button"
                            class="password-toggle-btn"
                            (click)="togglePasswordVisibility()"
                        >
                            <i
                                [class]="
                                    showPassword
                                        ? 'fas fa-eye-slash'
                                        : 'fas fa-eye'
                                "
                            ></i>
                        </button>
                    </div>
                    <div
                        class="text-danger"
                        *ngIf="
                            userForm.get('password').invalid &&
                            (userForm.get('password').dirty ||
                                userForm.get('password').touched)
                        "
                    >
                        <div
                            *ngIf="
                                userForm.get('password').errors?.['required']
                            "
                        >
                            Password is required.
                        </div>
                        <div
                            *ngIf="
                                userForm.get('password').errors?.['minlength']
                            "
                        >
                            Password must be at least 8 characters long.
                        </div>
                        <div
                            *ngIf="userForm.get('password').errors?.['pattern']"
                        >
                            Password must contain lowercase, uppercase, numbers,
                            and special characters.
                        </div>
                    </div>
                </div>

                <div class="form-group">
                    <label for="confirmPassword"
                        >Confirm Password
                        <span class="text-danger-required">*</span></label
                    >
                    <div class="password-input-container">
                        <input
                            formControlName="confirmPassword"
                            [type]="showConfirmPassword ? 'text' : 'password'"
                            id="confirmPassword"
                            class="form-control"
                            placeholder="Please confirm your password"
                            autocomplete="off"
                        />
                        <button
                            type="button"
                            class="password-toggle-btn"
                            (click)="toggleConfirmPasswordVisibility()"
                        >
                            <i
                                [class]="
                                    showConfirmPassword
                                        ? 'fas fa-eye-slash'
                                        : 'fas fa-eye'
                                "
                            ></i>
                        </button>
                    </div>
                    <div
                        class="text-danger"
                        *ngIf="
                            userForm.get('confirmPassword').invalid &&
                            (userForm.get('confirmPassword').dirty ||
                                userForm.get('confirmPassword').touched)
                        "
                    >
                        <div
                            *ngIf="
                                userForm.get('confirmPassword').errors?.[
                                    'required'
                                ]
                            "
                        >
                            Confirm Password is required.
                        </div>
                        <div
                            *ngIf="
                                userForm.get('confirmPassword').errors?.[
                                    'minlength'
                                ]
                            "
                        >
                            Confirm Password must be at least 8 characters long.
                        </div>
                        <div
                            *ngIf="
                                userForm.get('confirmPassword').errors?.[
                                    'pattern'
                                ]
                            "
                        >
                            Confirm Password must contain lowercase, uppercase,
                            numbers, and special characters.
                        </div>
                        <div
                            *ngIf="
                                userForm.get('confirmPassword').errors?.[
                                    'passwordMismatch'
                                ]
                            "
                        >
                            Passwords do not match.
                        </div>
                    </div>
                </div>
            </div>

            <!-- Submit Button -->
            <div class="form-actions">
                <button
                    class="btn close-btn-secondary"
                    type="button"
                    (click)="onClose()"
                >
                    Close
                </button>
                <button
                    class="btn submit-btn"
                    type="submit"
                    [disabled]="isLoading$ | async"
                >
                    <span class="submit-button-text" *ngIf="!isAuthLoading"
                        >Create User</span
                    >
                    <span class="submit-button-text" *ngIf="isAuthLoading"
                        >Creating...</span
                    >
                </button>
                <img
                    *ngIf="isLoading$ | async"
                    src="assets/img/loader.gif"
                    alt="Loading..."
                    class="loader-image mt-2"
                />
            </div>
        </form>
    </div>
</div>
